import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import ModelViewer from '@google/model-viewer'

createApp(App).use(router).use(ModelViewer).use(store).mount('#app')
